const INITIAL_STATE = {
	aguardando: false,
	indicadores: {

	},
	listaMetaVisita: []
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {

		case 'DASHBOARD_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

		case 'DASHBOARD_LISTADO':
            return {
				...state,
				indicadores: action.payload.data
			};

		case 'DASHBOARD_META_VISITA_LISTADO':
			return {
				...state,
				listaMetaVisita: action.payload.data
			}

        default:
            return state;
    }
}
